import {load} from "@fingerprintjs/fingerprintjs";

let loadingEle = null

let isLoading = false

let loadingObject = {}

// function showLoading(text) {
// 	if (isLoading === false) {
// 		const loadingContainer = document.createElement("div")
// 		loadingContainer.classList.add('loader-container')
//
// 		// 添加使元素显示在最上层的样式
// 		loadingContainer.style.position = "fixed"
// 		loadingContainer.style.zIndex = "9999"
// 		loadingContainer.style.top = "0"
// 		loadingContainer.style.left = "0"
// 		loadingContainer.style.width = "100%"
// 		loadingContainer.style.height = "100%"
//
// 		let loadingBody = document.createElement("div")
// 		loadingBody.classList.add('loader');
// 		loadingContainer.append(loadingBody)
// 		if (text) {
// 			loadingBody.innerText = text
// 		} else {
// 			loadingBody.innerText = ''
// 		}
//
// 		document.body.append(loadingContainer)
// 		isLoading = true
// 		loadingEle = loadingContainer
// 	}
// }

function showLoading(text = '', loadingId) {
	loadingObject[loadingId] = true
	if (isLoading) return;

	const loadingContainer = document.createElement('div');
	loadingContainer.className = 'loader-container';

	const loadingBox = document.createElement('div');
	loadingBox.className = 'loader-box';

	const spinner = document.createElement('div');
	spinner.className = 'loader-spinner';

	const caption = document.createElement('div');
	caption.className = 'loader-text';
	caption.textContent = text || '';

	loadingBox.appendChild(spinner);
	loadingBox.appendChild(caption);
	loadingContainer.appendChild(loadingBox);

	document.body.appendChild(loadingContainer);
	isLoading = true;
	loadingEle = loadingContainer;
}


function hideLoading(loadingId) {
	if (loadingId === 'all') {
		loadingObject = {}
	}
	delete loadingObject[loadingId]
	if (Object.keys(loadingObject).length !== 0) {
		return
	}
	if (loadingEle) {
		document.body.removeChild(loadingEle)
		isLoading = false
		loadingEle = null
	}
}

export {
	showLoading,
	hideLoading
}